"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const cgui_core_atoms_chip_1 = require("@campgladiator/cgui-core.atoms.chip");
const cgui_core_atoms_icon_1 = require("@campgladiator/cgui-core.atoms.icon");
const cgui_core_atoms_typography_1 = require("@campgladiator/cgui-core.atoms.typography");
const cgui_core_molecules_list_menu_1 = require("@campgladiator/cgui-core.molecules.list-menu");
const typography_module_scss_1 = __importDefault(require("@campgladiator/cgui-core.atoms.typography/typography.module.scss"));
const select_module_scss_1 = __importDefault(require("./select.module.scss"));
const Select = (_a) => {
    var { className = "", size = "default", invalid = false, disabled = false, placeholder, searchRecords = [], onInputChange, initialValue = [], shouldFilterRecords = true, recordsHeight = "initial", chipAppearance, onChangeSelectedRecords = () => { }, theme, maxChips = null } = _a, props = __rest(_a, ["className", "size", "invalid", "disabled", "placeholder", "searchRecords", "onInputChange", "initialValue", "shouldFilterRecords", "recordsHeight", "chipAppearance", "onChangeSelectedRecords", "theme", "maxChips"]);
    const [inputValue, setInputValue] = (0, react_1.useState)("");
    const [isActive, setIsActive] = (0, react_1.useState)(false);
    const [isExtended, setIsExtended] = (0, react_1.useState)(false);
    const [isOverflowingNotExtended, setIsOverflowingNotExtended] = (0, react_1.useState)(false);
    const [listItemsToShow, setListItemsToShow] = (0, react_1.useState)(searchRecords);
    const [selectedRecords, setSelectedRecords] = (0, react_1.useState)(initialValue);
    const [selectedRecordsIds, setSelectedRecordsIds] = (0, react_1.useState)(new Set());
    const [shouldShowListMenu, setShouldShowListMenu] = (0, react_1.useState)(false);
    const contentRef = (0, react_1.useRef)(null);
    const inputRef = (0, react_1.useRef)(null);
    const innerDivRef = (0, react_1.useRef)(null);
    const listMenuRef = (0, react_1.useRef)(null);
    const maxHeightInPxWhenNotExtended = 75;
    const formatClickableMenuItem = (record) => {
        return Object.assign(Object.assign({}, record), { handleClick: () => {
                setInputValue("");
                handleChipAddition(record);
            } });
    };
    const handleChipAddition = (listItemToAdd) => {
        const chipProps = {
            children: listItemToAdd.text,
        };
        if (!!listItemToAdd.icon) {
            chipProps["icon"] = Object.assign({}, listItemToAdd.icon);
        }
        else if (!!listItemToAdd.avatar) {
            chipProps["avatar"] = { src: listItemToAdd.avatar.src };
        }
        const newRecord = Object.assign({ itemId: listItemToAdd.itemId }, chipProps);
        updateSelectedRecordsWithMaxLimit(newRecord);
    };
    const updateSelectedRecordsWithMaxLimit = (newRecord) => {
        const newSelectedRecords = [...selectedRecords];
        if (maxChips !== null && maxChips <= selectedRecords.length) {
            newSelectedRecords.shift();
        }
        newSelectedRecords.push(newRecord);
        setSelectedRecords(newSelectedRecords);
    };
    const handleChipRemove = (idToRemove) => {
        const newSelectedRecords = selectedRecords.filter((record) => record.itemId !== idToRemove);
        setSelectedRecords(newSelectedRecords);
        setInputValue("");
    };
    const handleClear = () => {
        setSelectedRecords([]);
        setInputValue("");
    };
    (0, react_1.useEffect)(() => {
        onChangeSelectedRecords(selectedRecords);
    }, [selectedRecords]);
    const handleFocus = () => {
        inputRef.current.focus();
        innerDivRef.current.scrollTop = innerDivRef.current.scrollHeight;
    };
    const handleInputBlur = () => {
        setIsActive(false);
    };
    (0, react_1.useEffect)(() => {
        let newSearchRecords = searchRecords.filter((item) => item.type !== "item" || !selectedRecordsIds.has(item.itemId));
        if (shouldFilterRecords) {
            newSearchRecords = newSearchRecords.filter((item) => item.type !== "item" ||
                item.text.toLowerCase().includes(inputValue.toLowerCase()));
        }
        if (newSearchRecords.length === 0) {
            const noRecordsFoundItem = [
                Object.assign({ type: "item", itemId: "0", text: "No results found", active: false, disablePointer: true }, props),
            ];
            newSearchRecords.push(noRecordsFoundItem[0]);
        }
        setListItemsToShow(newSearchRecords);
    }, [inputValue, searchRecords]);
    (0, react_1.useEffect)(() => {
        setShouldShowListMenu(isActive && !!inputValue);
    }, [inputValue, isActive]);
    (0, react_1.useEffect)(() => {
        if (!!inputRef.current) {
            if (maxHeightInPxWhenNotExtended -
                inputRef.current.offsetTop -
                inputRef.current.offsetHeight <
                0) {
                setIsOverflowingNotExtended(true);
            }
            else {
                setIsOverflowingNotExtended(false);
                setIsExtended(false);
            }
        }
    }, [inputValue, selectedRecords]);
    (0, react_1.useEffect)(() => {
        handleFocus();
    }, [inputValue, selectedRecords, isExtended]);
    (0, react_1.useEffect)(() => {
        setSelectedRecordsIds(new Set(selectedRecords.map((record) => record.itemId)));
    }, [selectedRecords]);
    (0, react_1.useEffect)(() => {
        const handleClickOutside = (event) => {
            if (contentRef.current &&
                !contentRef.current.contains(event.target)) {
                handleInputBlur();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [contentRef]);
    const areSelectedRecords = selectedRecords.length > 0;
    const styles = theme || select_module_scss_1.default;
    return (react_1.default.createElement("div", Object.assign({ ref: contentRef, className: (0, classnames_1.default)(styles.content, className) }, props),
        react_1.default.createElement("div", { className: (0, classnames_1.default)(styles.outsideWrapper, {
                [styles.active]: isActive,
                [styles.extended]: isExtended,
            }), "data-invalid": invalid, "data-disabled": disabled, onClick: handleFocus, style: isExtended ? {} : { maxHeight: `${maxHeightInPxWhenNotExtended}px` } },
            react_1.default.createElement("div", { ref: innerDivRef, className: (0, classnames_1.default)(styles.innerWrapper, {
                    [styles.noRecords]: !areSelectedRecords,
                }) },
                selectedRecords.map((record) => {
                    const { itemId } = record, rest = __rest(record, ["itemId"]);
                    return (react_1.default.createElement(cgui_core_atoms_chip_1.Chip, Object.assign({ key: itemId }, rest, chipAppearance, { onRemove: () => handleChipRemove(itemId), removeIcon: true })));
                }),
                !!placeholder && !inputValue && !areSelectedRecords && (react_1.default.createElement(cgui_core_atoms_typography_1.Paragraph, { weight: "book", size: "small", className: styles.placeholder }, placeholder)),
                react_1.default.createElement("div", { className: (0, classnames_1.default)(styles.wrapper, typography_module_scss_1.default.paragraph), "data-value": inputValue, "data-size": "small" },
                    react_1.default.createElement("input", { className: (0, classnames_1.default)(styles.input), disabled: disabled, ref: inputRef, value: inputValue, onFocus: () => setIsActive(true), onChange: (e) => {
                            setInputValue(e.target.value);
                            !!onInputChange && onInputChange(e.target.value);
                        } })),
                react_1.default.createElement("div", { className: styles.controls },
                    !isExtended && isOverflowingNotExtended && (react_1.default.createElement(cgui_core_atoms_typography_1.Paragraph, { size: "xsmall", className: styles.showText, onClick: () => setIsExtended(true) }, "Show all")),
                    isExtended && (react_1.default.createElement(cgui_core_atoms_typography_1.Paragraph, { size: "xsmall", className: styles.showText, onClick: () => setIsExtended(false) }, "Show less")),
                    areSelectedRecords && (react_1.default.createElement("button", { className: styles.clearBtn, onClick: handleClear },
                        react_1.default.createElement(cgui_core_atoms_icon_1.Icon.Monochrome, { name: "times-circle", className: styles.clearIcon }))))),
            react_1.default.createElement("input", { name: props.name, id: props.id, value: selectedRecords.map((record) => record.itemId), readOnly: true, hidden: true })),
        shouldShowListMenu && (react_1.default.createElement(cgui_core_molecules_list_menu_1.ListMenu, { ref: listMenuRef, selection: "multi", initialActiveIds: selectedRecordsIds, className: styles.menu, style: { height: recordsHeight }, items: listItemsToShow.map((record) => record.type === "item" ? formatClickableMenuItem(record) : record) }))));
};
exports.default = Select;
//# sourceMappingURL=select.js.map